/**
 * Global HR booking reference display (8 digits stored; UI shows HR-XXXXXXXX).
 * @param {string|null|undefined} raw
 * @returns {string|null}
 */
export function formatHrBookingRef(raw) {
  const s = raw == null ? "" : String(raw).trim();
  if (!s || !/^\d{8}$/.test(s)) return null;
  return `HR-${s}`;
}
